export default __webpack_public_path__ + "static/media/Email_Default.8536adca.png";